import {Typography} from 'antd';
import React, {FC, ReactNode} from 'react';
import './custom-card-title.less';

export interface ICustomCardStyleProps {
    titleClassName?: string;
    cardClassName?: string;
}
interface ICustomCardTitleProps {
    text?: string;
    extra?: ReactNode;
    customCardStyleProps?: ICustomCardStyleProps;
}

export const CustomCardTitle: FC<ICustomCardTitleProps> = ({
    text, extra, customCardStyleProps,
}: ICustomCardTitleProps) => (
    text ? (
        <div className={customCardStyleProps?.cardClassName
            ? customCardStyleProps?.cardClassName
            : 'custom-card-title'}
        >
            <Typography.Title className={customCardStyleProps?.titleClassName
                ? customCardStyleProps?.titleClassName
                : 'title'}
            >{text}
            </Typography.Title>
            {extra && extra}
        </div>
    ) : null
);
